import { VerifyCompanyDomainResponse } from '../../services/user/payload/verify-company-domain.payload';
export class VerifyUserExistModel {
    code: string;
    message: string;
    companyCode: string;
    tempVerifyUrl: string;
    companyList: VerifyCompanyDomainResponse[];
}

export class CompanyList {
    companyId: number;
    companyName: string;
    companyNameTranslate: string;
}


// WEBPACK FOOTER //
// ./src/app/model/user/verify-user-exist-model.ts